import React, { Component } from "react";

import { withUnits } from "../../../../shared/containers/containerUnits";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getCarsTypeName } from "../../../sections/cars/static.carsTypes";

import styles from "./userUnitBar.module.scss";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import { withUsers } from "../../../../shared/containers/containerUsers";

class UserUnitListItem extends Component {
  constructor(props) {
    super(props);

    this.state = { isCheck: false };
  }

  componentDidMount() {
    const { currentUser, data } = this.props;
    const { isCheck } = this.state;

    const _isCheck = currentUser.units.some((x) => {
      return x.id === data.id;
    });

    if (isCheck !== _isCheck) {
      this.setState({ isCheck: _isCheck });
    }
  }

  componentDidUpdate(preProps) {
    const { currentUser, data } = this.props;
    const { isCheck } = this.state;

    const _isCheck = currentUser.units.some((x) => {
      return x.id === data.id;
    });

    if (isCheck !== _isCheck) {
      this.setState({ isCheck: _isCheck });
    }
  }

  onClickHandler() {
    const { currentUser, data, onCreateUserUnit, onDeleteUserUnit } = this.props;
    const { isCheck } = this.state;

    if (currentUser.role.roleType === 500) {
      const unit = { id: data.id, title: data.unit.title, registerNumber: data.unit.registerNumber };

      if (isCheck) onDeleteUserUnit(currentUser, unit);
      else onCreateUserUnit(currentUser, unit);
    }
  }

  render() {
    const { data, currentUser } = this.props;
    const { isCheck } = this.state;

    const getStatusStyles = () => {
      switch (data.unit.inActive ? "inActive" : getCarsTypeName(data.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        case "inActive":
          return styles.container_carNumber_inActive;
        default:
          return null;
      }
    };

    return (
      <div className={styles.carsListItemWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            <TooltipWrapper title={data.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{data.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{data.unit.title}</div>

                  <div>{data.unit.registerNumber}</div>
                </div>
              </div>

              {currentUser.role.roleType === 500 ? (
                <div
                  className={styles.container_params}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onClickHandler();
                  }}
                >
                  <TooltipWrapper
                    title={
                      isCheck
                        ? `Убрать ${data.unit.title} ${data.unit.registerNumber}`
                        : `Добавить ${data.unit.title} ${data.unit.registerNumber}`
                    }
                    position="top"
                  >
                    {isCheck ? (
                      <div className={styles.container_itemChecked}>
                        <CheckCircleIcon fontSize="small" />
                      </div>
                    ) : (
                      <div className={styles.container_itemUnchecked}>
                        <CheckCircleOutlineIcon fontSize="small" />
                      </div>
                    )}
                  </TooltipWrapper>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withUsers(withUnits(React.memo(UserUnitListItem)));
